/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps } from '@mui/material';

export const headerLogoContainerSX = (isMobile: boolean): SxProps => ({
	img: {
		height: isMobile ? '48px' : '60px',
		width: isMobile ? '48px' : '60px',
	},
});
